<template>
  <div>
    <!-- SECCIÓN PLAYLIST REQUEST ÚNICAMENTE -->
    <section ref="raizPlaylist" class="lluvia-sobres">
      <!-- Elementos decorativos laterales SUPERIORES (Flores y Ramas) -->
      <div class="decoracion-lateral decoracion-izq">
        <img :src="floresPng" alt="Flores Izquierda Sup" class="flor-decorativa a-animar-flor-play-izq" />
        <img :src="ramasPng" alt="Ramas Izquierda Sup" class="rama-decorativa a-animar-rama-play-izq" />
      </div>
      <div class="decoracion-lateral decoracion-der">
        <img :src="floresPng" alt="Flores Derecha Sup" class="flor-decorativa a-animar-flor-play-der" />
        <img :src="ramasPng" alt="Ramas Derecha Sup" class="rama-decorativa a-animar-rama-play-der" />
      </div>

      <!-- Elementos decorativos laterales INFERIORES (Flores y Ramas) -->
      <div class="decoracion-lateral decoracion-izq-inf">
        <img :src="floresPng" alt="Flores Izquierda Inf" class="flor-decorativa a-animar-flor-play-izq-inf" />
        <img :src="ramasPng" alt="Ramas Izquierda Inf" class="rama-decorativa a-animar-rama-play-izq-inf" />
      </div>
      <div class="decoracion-lateral decoracion-der-inf">
        <img :src="floresPng" alt="Flores Derecha Inf" class="flor-decorativa a-animar-flor-play-der-inf" />
        <img :src="ramasPng" alt="Ramas Derecha Inf" class="rama-decorativa a-animar-rama-play-der-inf" />
      </div>

      <div class="contenido">
        <!-- Imagen cel.avif con animación elástica e independiente -->
        <img :src="bolaDiscoPng" alt="Celular" class="bola-disco a-animar-cel" />

        <h2 class="titulo a-animar-letras">
          <span class="serif">Playlist Request!</span>
        </h2>

        <p class="texto a-animar-letras">
          We’re building our party playlist! Let us know your favorite song to dance to!
        </p>

        <!-- SEPARADOR -->
        <div class="separador a-animar-letras">
          <span class="linea"></span>
          <span class="rombo">♦</span>
          <span class="linea"></span>
        </div>

        <!-- Botón interactivo para enviar sugerencias por SMS -->
        <div class="opcion-card a-animar-letras BoxSuggestion">
          <p class="indicacion">Send your suggestions here:</p>
          <a 
            :href="smsLink" 
            class="boton-sugerencia"
          >
            Playlist
          </a>
        </div>
      </div>

      <div ref="lluviaPlayIzq" class="lluvia lluvia-izq"></div>
      <div ref="lluviaPlayDer" class="lluvia lluvia-der"></div>

      <div class="rasgado rasgado-inferior"></div>
    </section>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted, computed, nextTick } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import sobrePng from '@/assets/ss.png'
import floresPng from '@/assets/f.png'
import ramasPng from '@/assets/ramas.png'
import bolaDiscoPng from '@/assets/cel.avif'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'LluviaDeSobres',
  setup() {
    const raizPlaylist = ref(null)
    const lluviaPlayIzq = ref(null)
    const lluviaPlayDer = ref(null)

    let stInstancePlaylist = null

    // Detecta si es un dispositivo iOS/Safari para dar formato correcto al enlace de SMS
    const smsLink = computed(() => {
      const phoneNumber = '13238123103'
      const message = 'Hi! Here is my song suggestion for the playlist: '
      const isIOS = typeof window !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent)
      
      const separator = isIOS ? '&' : '?'
      return `sms:${phoneNumber}${separator}body=${encodeURIComponent(message)}`
    })

    const crearLluvia = (contenedorEl, lado, cantidad) => {
      if (!contenedorEl) return
      for (let i = 0; i < cantidad; i++) {
        const el = document.createElement('img')
        el.src = sobrePng
        el.className = 'sobre-lluvia'
        contenedorEl.appendChild(el)

        gsap.fromTo(
          el,
          { xPercent: lado === 'der' ? 110 : -10, yPercent: -10, opacity: 0 },
          {
            xPercent: lado === 'der' ? -20 : 120,
            yPercent: 140,
            opacity: 0.9,
            duration: 2.2,
            ease: 'power2.out',
            onComplete: () => el.remove()
          }
        )
      }
    }

    onMounted(async () => {
      await nextTick()

      // --- ANIMACIÓN SECCIÓN (PLAYLIST REQUEST) ---
      const elementosLetras = raizPlaylist.value.querySelectorAll('.a-animar-letras')
      const imagenCel = raizPlaylist.value.querySelector('.a-animar-cel')
      
      const florPlayIzq = raizPlaylist.value.querySelector('.a-animar-flor-play-izq')
      const florPlayDer = raizPlaylist.value.querySelector('.a-animar-flor-play-der')
      const ramaPlayIzq = raizPlaylist.value.querySelector('.a-animar-rama-play-izq')
      const ramaPlayDer = raizPlaylist.value.querySelector('.a-animar-rama-play-der')

      const florPlayIzqInf = raizPlaylist.value.querySelector('.a-animar-flor-play-izq-inf')
      const florPlayDerInf = raizPlaylist.value.querySelector('.a-animar-flor-play-der-inf')
      const ramaPlayIzqInf = raizPlaylist.value.querySelector('.a-animar-rama-play-izq-inf')
      const ramaPlayDerInf = raizPlaylist.value.querySelector('.a-animar-rama-play-der-inf')

      // Inicialización de estados ocultos diferenciados
      gsap.set(elementosLetras, { opacity: 0, y: 40 })
      gsap.set(imagenCel, { opacity: 0, scale: 0.3, rotation: -15 })
      
      gsap.set([florPlayIzq, florPlayDer, florPlayIzqInf, florPlayDerInf], { opacity: 0, scale: 0.7, rotation: (i) => i % 2 === 0 ? -15 : 15 })
      gsap.set([ramaPlayIzq, ramaPlayDer], { opacity: 0, y: -50, scaleY: 0.8 })
      gsap.set([ramaPlayIzqInf, ramaPlayDerInf], { opacity: 0, y: 50, scaleY: 0.8 })

      stInstancePlaylist = ScrollTrigger.create({
        trigger: raizPlaylist.value,
        start: 'top 85%',
        once: true,
        onEnter: () => {
          crearLluvia(lluviaPlayDer.value, 'der', 10)
          crearLluvia(lluviaPlayIzq.value, 'izq', 10)

          const tlPrincipal = gsap.timeline()
          
          tlPrincipal
            // 1. Entrada de la imagen cel.avif (Animación elástica/rebotante)
            .to(imagenCel, {
              opacity: 1,
              scale: 1,
              rotation: 0,
              duration: 1.6,
              ease: 'elastic.out(1, 0.6)'
            })
            // 2. Entrada de las flores y ramas decorativas laterales
            .to([florPlayIzq, florPlayDer, florPlayIzqInf, florPlayDerInf], {
              opacity: 1,
              scale: 1,
              rotation: 0,
              duration: 1.2,
              ease: 'power2.out'
            }, '-=1.1')
            .to([ramaPlayIzq, ramaPlayDer, ramaPlayIzqInf, ramaPlayDerInf], {
              opacity: 1,
              y: 0,
              scaleY: 1,
              duration: 1.4,
              ease: 'power3.out'
            }, '-=0.8')
            // 3. Entrada escalonada para las letras y el botón final
            .to(elementosLetras, { 
              opacity: 1, 
              y: 0, 
              duration: 1.0, 
              stagger: 0.12, 
              ease: 'power2.out' 
            }, '-=0.9')
        }
      })
    })

    onUnmounted(() => {
      stInstancePlaylist?.kill()
    })

    return {
      raizPlaylist,
      sobrePng,
      floresPng,
      ramasPng,
      bolaDiscoPng,
      smsLink
    }
  }
}
</script>

<style scoped>
/* CONTENEDOR */
.lluvia-sobres{
  position: relative;
  max-width: 520px;
  margin: 0 auto;
  padding: 48px 20px 56px;
  text-align: center;
  background: #e793b6;
  overflow: hidden;
}

/* DECORACIÓN LATERAL SUPERIOR */
.decoracion-lateral {
  position: absolute;
  top: 10px;
  width: 90px;
  z-index: 3;
  display: flex;
  flex-direction: column;
  align-items: center;
  pointer-events: none;
}

/* DECORACIÓN LATERAL INFERIOR */
.decoracion-lateral-izq-inf {
  position: absolute;
  bottom: 20px;
  left: -15px;
  width: 90px;
  z-index: 3;
  display: flex;
  flex-direction: column;
  align-items: center;
  pointer-events: none;
  transform: scaleY(-1);
}

.decoracion-lateral-der-inf {
  position: absolute;
  bottom: 20px;
  right: -15px;
  width: 90px;
  z-index: 3;
  display: flex;
  flex-direction: column;
  align-items: center;
  pointer-events: none;
  transform: scale(-1);
}

.decoracion-izq {
  left: -15px;
}

.decoracion-der {
  right: -15px;
  transform: scaleX(-1);
}

.flor-decorativa {
  width: 100%;
  height: auto;
  position: relative;
  z-index: 4;
  margin-top:-45px;
}

.rama-decorativa {
  width: 75%;
  height: auto;
  margin-top: -42px;
  transform-origin: top center;
  z-index: 2;
}

/* IMAGEN PRINCIPAL (cel.avif) */
.bola-disco {
  width: 140px;
  height: auto;
  display: inline-block;
  margin: 0 auto 20px;
  filter: drop-shadow(0 8px 16px rgba(0,0,0,0.15));
}

/* CONTENIDO */
.contenido{
  position: relative;
  z-index: 2;
}

/* TITULO */
.titulo{
  margin: 0 0 10px;
  color: #fff;
  line-height: 1.05;
}

.titulo .serif{
  font-family: 'britishgruesa', serif;
  font-size: 56px;
  display: inline-block;
}

/* TEXTO */
.texto{
  font-family: 'quote', serif;
  font-size: 17px;
  line-height: 1.5;
  color: #fff;
  max-width: 420px;
  margin: 12px auto 18px;
}

/* SEPARADOR */
.separador {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin: 24px auto;
  max-width: 250px;
  width: 100%;
}

.separador .linea {
  flex: 1;
  display: inline-block;
  height: 1px;
  background-color: rgba(255, 255, 255, 0.6);
}

.separador .rombo {
  color: #fff;
  font-size: 12px;
  opacity: 0.8;
  line-height: 1;
}

/* CONTENEDOR DE SUGERENCIA */
.opcion-card {
  backdrop-filter: blur(4px);
  border-radius: 12px;
  padding: 16px;
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.BoxSuggestion {
  max-width: 360px;
  margin: 0 auto;
}

.opcion-card p {
  font-family: 'quote', serif;
  font-size: 20px;
  margin: 0;
  opacity: 0.9;
}

.opcion-card .indicacion {
  font-size: 19px;
  margin-bottom: 16px;
  opacity: 0.95;
}

/* EL BOTÓN INTERACTIVO */
.boton-sugerencia {
  font-family: 'britishgruesa', serif;
  font-size: 24px;
  font-weight: bold;
  color: #fff;
  text-decoration: none;
  background: rgba(255, 255, 255, 0.25);
  padding: 12px 32px;
  border-radius: 30px;
  letter-spacing: 0.05em;
  transition: background 0.3s ease, transform 0.2s ease, box-shadow 0.3s ease;
  display: inline-block;
  cursor: pointer;
  border: 1px solid rgba(255, 255, 255, 0.4);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
}

.boton-sugerencia:hover {
  background: rgba(255, 255, 255, 0.35);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
}

.boton-sugerencia:active {
  transform: translateY(1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

/* LLUVIA */
.lluvia{
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 1;
}

.sobre-lluvia{
  position: absolute;
  width: 28px;
  top: -10%;
  opacity: .9;
  filter: drop-shadow(0 4px 8px rgba(0,0,0,.1));
}
</style>
<style scoped>
/* CONTENEDOR */
.lluvia-sobres{
  position: relative;
  max-width: 520px;
  margin: 0 auto;
  padding: 48px 20px 56px;
  text-align: center;
  background: #e793b6;
  overflow: hidden;
}

/* DECORACIÓN LATERAL SUPERIOR */
.decoracion-lateral {
  position: absolute;
  top: 10px;
  width: 90px;
  z-index: 3;
  display: flex;
  flex-direction: column;
  align-items: center;
  pointer-events: none;
}

/* DECORACIÓN LATERAL INFERIOR */
.decoracion-lateral-izq-inf {
  position: absolute;
  bottom: 20px;
  left: -15px;
  width: 90px;
  z-index: 3;
  display: flex;
  flex-direction: column;
  align-items: center;
  pointer-events: none;
  transform: scaleY(-1);
}

.decoracion-lateral-der-inf {
  position: absolute;
  bottom: 20px;
  right: -15px;
  width: 90px;
  z-index: 3;
  display: flex;
  flex-direction: column;
  align-items: center;
  pointer-events: none;
  transform: scale(-1);
}

.decoracion-izq {
  left: -15px;
}

.decoracion-der {
  right: -15px;
  transform: scaleX(-1);
}

.flor-decorativa {
  width: 100%;
  height: auto;
  position: relative;
  z-index: 4;
  margin-top:-45px;
}

.rama-decorativa {
  width: 75%;
  height: auto;
  margin-top: -42px;
  transform-origin: top center;
  z-index: 2;
}

/* BOLA DE DISCO */
.bola-disco {
  width: 140px;
  height: auto;
  display: inline-block;
  margin: 0 auto 20px;
  filter: drop-shadow(0 8px 16px rgba(0,0,0,0.15));
}

/* CONTENIDO */
.contenido{
  position: relative;
  z-index: 2;
}

/* TITULO */
.titulo{
  margin: 0 0 10px;
  color: #fff;
  line-height: 1.05;
}

.titulo .serif{
  font-family: 'britishgruesa', serif;
  font-size: 56px;
  display: inline-block;
}

/* TEXTO */
.texto{
  font-family: 'quote', serif;
  font-size: 17px;
  line-height: 1.5;
  color: #fff;
  max-width: 420px;
  margin: 12px auto 18px;
}

/* SEPARADOR */
.separador {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin: 24px auto;
  max-width: 250px;
  width: 100%;
}

.separador .linea {
  flex: 1;
  display: inline-block;
  height: 1px;
  background-color: rgba(255, 255, 255, 0.6);
}

.separador .rombo {
  color: #fff;
  font-size: 12px;
  opacity: 0.8;
  line-height: 1;
}

/* CONTENEDOR DE SUGERENCIA */
.opcion-card {
  backdrop-filter: blur(4px);
  border-radius: 12px;
  padding: 16px;
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.BoxSuggestion {
  max-width: 360px;
  margin: 0 auto;
}

.opcion-card p {
  font-family: 'quote', serif;
  font-size: 20px;
  margin: 0;
  opacity: 0.9;
}

.opcion-card .indicacion {
  font-size: 19px;
  margin-bottom: 12px;
  opacity: 0.95;
}

/* EL BOTÓN INTERACTIVO */
.boton-sugerencia {
  font-family: 'britishgruesa', serif;
  font-size: 28px;
  font-weight: bold;
  color: #fff;
  text-decoration: none;
  background: rgba(255, 255, 255, 0.25);
  padding: 8px 24px;
  border-radius: 30px;
  letter-spacing: 0.05em;
  transition: background 0.3s ease, transform 0.2s ease;
  display: inline-block;
  cursor: pointer;
  border: 1px solid rgba(255, 255, 255, 0.4);
}

.boton-sugerencia:hover {
  background: rgba(255, 255, 255, 0.4);
  transform: scale(1.03);
}

.boton-sugerencia:active {
  transform: scale(0.98);
}

/* LLUVIA */
.lluvia{
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 1;
}

.sobre-lluvia{
  position: absolute;
  width: 28px;
  top: -10%;
  opacity: .9;
  filter: drop-shadow(0 4px 8px rgba(0,0,0,.1));
}
</style>